export default class Pipeline{
    pipelineId: string;
    viewSettings: any;
    pipelineStages: any[];
    filterOptions: any;
    initialGet: boolean;
    requestObject: any;

    constructor(pipelineId: string, viewSettings: any, requestObject: any, pipelineStages: any[], filterOptions: any, initialGet: boolean){
        this.pipelineId = pipelineId;
        this.viewSettings = viewSettings;
        this.requestObject = requestObject;
        this.pipelineStages = pipelineStages;
        this.filterOptions = filterOptions;
        this.initialGet = initialGet;
    }
}